// extracted by mini-css-extract-plugin
export default {"categoryBox":"styles_categoryBox__qjlwn","title":"styles_title__WyvQF"};